import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import BlockIcon from '@mui/icons-material/Block';
import LogoutIcon from '@mui/icons-material/Logout';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function PendingApproval() {
  const navigate = useNavigate();
  const location = useLocation();
  const status = location.state?.status || 'pending_approval';
  const empresaNombre = location.state?.empresa_nombre || 'la empresa';
  const userName = location.state?.name || '';

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch {}
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/login');
  };

  const isRejected = status === 'rejected';

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    }}>
      <Box sx={{
        maxWidth: 440, width: '100%', mx: 2, p: 4, textAlign: 'center',
        borderRadius: 4,
        background: 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        border: '1px solid rgba(255,255,255,0.5)',
      }}>
        <Box sx={{
          width: 80, height: 80, borderRadius: '50%', mx: 'auto', mb: 3,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          bgcolor: isRejected ? '#fef2f215' : '#eff6ff',
          border: `2px solid ${isRejected ? '#ef4444' : '#3b82f6'}`,
        }}>
          {isRejected
            ? <BlockIcon sx={{ fontSize: 40, color: '#ef4444' }} />
            : <HourglassEmptyIcon sx={{ fontSize: 40, color: '#3b82f6' }} />
          }
        </Box>

        {isRejected ? (
          <>
            <Typography sx={{ fontWeight: 700, fontSize: 20, color: '#134e4a', mb: 1 }}>
              Solicitud rechazada
            </Typography>
            <Typography sx={{ color: '#64748b', fontSize: 14, mb: 3, lineHeight: 1.6 }}>
              Tu solicitud de acceso fue rechazada por el administrador.
              Si crees que es un error, contacta directamente al administrador de la empresa.
            </Typography>
          </>
        ) : (
          <>
            <Typography sx={{ fontWeight: 700, fontSize: 20, color: '#134e4a', mb: 1 }}>
              Solicitud pendiente
            </Typography>
            <Typography sx={{ color: '#64748b', fontSize: 14, mb: 1, lineHeight: 1.6 }}>
              {userName ? `Hola ${userName}, t` : 'T'}u solicitud de acceso a
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 16, color: '#164e63', mb: 1 }}>
              {empresaNombre}
            </Typography>
            <Typography sx={{ color: '#64748b', fontSize: 14, mb: 3, lineHeight: 1.6 }}>
              está pendiente de aprobación. El administrador de la empresa
              revisará tu solicitud pronto.
            </Typography>
          </>
        )}

        <Button variant="outlined" startIcon={<LogoutIcon />} onClick={handleLogout}
          sx={{
            borderColor: '#94a3b8', color: '#64748b', borderRadius: 3,
            textTransform: 'none', fontWeight: 600,
            '&:hover': { borderColor: '#64748b', bgcolor: '#f1f5f9' }
          }}>
          Cerrar sesión
        </Button>
      </Box>
    </Box>
  );
}
